import { createForm } from '@morgan-morgan/core';

createForm('.case-evaluation-form-container .form-container', {
    formId: window.NL.variables.forms.caseEvalForm
});


// WEBPACK FOOTER //
// ./assets/js/app/includes/case-evaluation-form.js